import script from "./Close.vue?vue&type=script&lang=ts&setup=true"
export * from "./Close.vue?vue&type=script&lang=ts&setup=true"

import "./Close.vue?vue&type=style&index=0&id=323f164c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4153695745/src/bitbucket.org/labtravelfactory/booking-funnel-xftless/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-323f164c"]])

export default __exports__